import axios from "utils/axios";
import { LOOKUP_POSTAL_PINCODE_URL } from "config/services";

export const lookupPostalPincode = async (pinCode, signal) => {
  if (!/^[1-9]\d{5}$/.test(pinCode)) throw new Error("Enter a valid 6-digit pincode.");
  const response = await axios.get(`${LOOKUP_POSTAL_PINCODE_URL}/${pinCode}`, {
    signal,
    // Allow the backend's 12-second retry deadline plus gateway/connection overhead.
    timeout: 15000,
  });
  const payload = response?.data?.payload;
  if (payload?.pinCode !== pinCode || !Array.isArray(payload.areas) || !payload.areas.length || payload.areas.length > 500 ||
      !payload.areas.every((area) => area && ["area", "division", "region", "state"].every((key) => typeof area[key] === "string" && area[key].trim()))) {
    throw new Error("Postal lookup is temporarily unavailable. Please enter the address manually.");
  }
  return payload;
};
